// Display-only decoding of punycode ("xn--") labels (RFC 3492). Stored origins stay ASCII.
const BASE = 36, TMIN = 1, TMAX = 26, SKEW = 38, DAMP = 700;
function adapt(delta: number, points: number, first: boolean): number {
  delta = first ? Math.floor(delta / DAMP) : delta >> 1;
  delta += Math.floor(delta / points);
  let k = 0;
  for (; delta > ((BASE - TMIN) * TMAX) >> 1; k += BASE) delta = Math.floor(delta / (BASE - TMIN));
  return k + Math.floor(((BASE - TMIN + 1) * delta) / (delta + SKEW));
}
function digit(code: number): number {
  if (code >= 48 && code <= 57) return code - 22;
  if (code >= 97 && code <= 122) return code - 97;
  if (code >= 65 && code <= 90) return code - 65;
  return -1;
}
function decodeLabel(input: string): string | null {
  const split = input.lastIndexOf('-'), output = split > 0 ? [...input.slice(0, split)].map(char => char.codePointAt(0)!) : [];
  let n = 128, i = 0, bias = 72;
  for (let index = split > 0 ? split + 1 : 0; index < input.length;) {
    const old = i;
    for (let w = 1, k = BASE; ; k += BASE) {
      if (index >= input.length) return null;
      const value = digit(input.charCodeAt(index++));
      if (value < 0) return null;
      i += value * w;
      const t = k <= bias ? TMIN : k >= bias + TMAX ? TMAX : k - bias;
      if (value < t) break;
      w *= BASE - t;
    }
    bias = adapt(i - old, output.length + 1, old === 0);
    n += Math.floor(i / (output.length + 1));
    i %= output.length + 1;
    if (n > 0x10ffff) return null;
    output.splice(i++, 0, n);
  }
  return String.fromCodePoint(...output);
}
export function hostnameToUnicode(hostname: string): string {
  return hostname.split('.').map(label => label.toLowerCase().startsWith('xn--') ? decodeLabel(label.slice(4)) ?? label : label).join('.');
}
export function originToUnicode(origin: string): string {
  try { const url = new URL(origin); return `${url.protocol}//${hostnameToUnicode(url.hostname)}${url.port ? `:${url.port}` : ''}`; }
  catch { return origin; }
}
